import { Injectable, NgModule } from "@angular/core";

import { AngularFireDatabase } from "@angular/fire/compat/database";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { BehaviorSubject } from "rxjs";
import * as firebase from "firebase/app";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminService } from "./admin.service";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { ChatMessage } from "../shared/models/chatMessage";
import { Chat } from "../shared/models/chat";
import { chatEnvironment } from "../../environments/chatEnvironment";
import { apiUrl } from "../global/global";

@Injectable({
    providedIn: "root"

})

export class ChatService {
    user: any;
    firebaseUsers = chatEnvironment.users;
    firebaseMessage = chatEnvironment.messages;
    firebaseChats = chatEnvironment.chats;
    firebaseJobs = chatEnvironment.jobs;
    firebaseNotification = chatEnvironment.notifications;
    //public chat_dialog_id: any;
    private _ChatMessages = new BehaviorSubject<any[]>([]);
    readonly ChatMessages = this._ChatMessages.asObservable();
    private _Chats = new BehaviorSubject<any[]>([]);
    readonly Chats = this._Chats.asObservable();
    private dataStore: { chats: Chat[], messages: ChatMessage[] } = { chats: [], messages: [] };
    //userName: Observable<string>;
    public currentUser: any;
    public unReadMessageCount: any;
    public lastmessageTime: any;
    private messageListener: any;
    constructor(private api: AdminService, private db: AngularFireDatabase, private afAuth: AngularFireAuth, private router: Router, private route: ActivatedRoute) { }
    /*addChat() {}
    addMessage(msg: string) {}*/
    /*clearChats() {
        this.dataStore.messages = [];
        this._ChatMessages.next(Object.assign({}, this.dataStore).messages);
    }

    clearMessages() {
        this.dataStore.messages = [];
        this._ChatMessages.next(Object.assign({}, this.dataStore).messages);
    }*/

    /*getChats() {
        let userId = 'ID_' + String(this.currentUser);
        this.db.list(`${this.firebaseChats}`,
            query => query
            .orderByChild("seller_id")
            .equalTo(userId)
            .limitToLast(10)
        ).valueChanges().subscribe(list => {
            console.log(list);
            this.dataStore.chats = list ? <Array<Chat>>list : [];
            this._Chats.next(Object.assign({}, this.dataStore).chats);
            console.log(this._Chats);
           // _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        });
    }*/

    async sendMessage(msg: string, chatDiologId: string, jobId: string, userId: string, unreadMessageCount: string, myblock_statys: string, lastMessageTimeOthertext: string, lastMessageOthertext: string, otherUserUnreadCounttext: string) {
        var last_message_time = new Date().getTime();
        var serverTime = await this.serverTime();
        var readStatusArr = {};
        readStatusArr[userId] = userId;
        var messagePush = this.db.list(`${this.firebaseMessage}/${chatDiologId}`).push({
            "attachment_url": "",
            "chat_dialog_id": chatDiologId,
            "firebase_message_time": serverTime,
            "message": msg,
            "message_time": last_message_time,
            "message_type": 1,
            "job_id": jobId,
            "user_id": userId,
            "receiver_id": userId,
            "sender_id": jobId,
        });
        // console.log('this._messageBody......',messagePush)

        var aa = this.db.object(`${this.firebaseMessage}/${chatDiologId}/${messagePush.key}/`).update({
            "message_id": messagePush.key
        });
        this.removeMessage(chatDiologId, messagePush.key)
        this.db.list(`${this.firebaseNotification}`).push({
            "attachment_url": "",
            "chat_dialog_id": chatDiologId,
            "firebase_message_time": serverTime,
            "message": msg,
            "message_id": messagePush.key,
            "message_time": last_message_time,
            "message_type": 1,
            "receiver_id": userId,
            "sender_id": jobId
        });
        var messageTimeArr = {};
        messageTimeArr[userId] = last_message_time;
        var messageTypeArr = {};
        messageTypeArr[userId] = 1;
        messageTypeArr[jobId] = 1;
        var lastMessageArr = {};
        lastMessageArr[userId] = msg;
        lastMessageArr[jobId] = msg;
        var deleteTime = {};
        deleteTime[userId] = 0;
        deleteTime[jobId] = 0;
        var unreadMessageArr = {};
        var message_count = '1';
        if (myblock_statys == '0') {
            unreadMessageArr[userId] = parseInt(unreadMessageCount) + parseInt(message_count);
        } else {
            unreadMessageArr[userId] = parseInt(unreadMessageCount);
        }
        unreadMessageArr[jobId] = 0;
        this.db.object(`${this.firebaseChats}/${chatDiologId}`).update({
            "last_message_time": last_message_time,
            "last_message_type": 1,
            "last_message_sender_id": jobId,
            "last_message": lastMessageArr,
            "last_message_id": messagePush.key,
            "unread_count": unreadMessageArr
        });
        // setTimeout(()=>{                           //<<<---using ()=> syntax
        //     var ab = this.db.object(`${this.firebaseMessage}/${chatDiologId}/${messagePush.key}/`).remove();
        //     console.log('ab:::::',ab);
        // }, 10000);

    }

    async sendMessageDocument(msg: string, chatDiologId: string, jobId: string, userId: string, unreadMessageCount: string, myblock_statys: string, lastMessageTimeOthertext: string, lastMessageOthertext: string, otherUserUnreadCounttext: string, messageType) {
        var last_message_time = new Date().getTime()
        var serverTime = await this.serverTime();
        var readStatusArr = {};
        readStatusArr[userId] = userId;
        var messagePush = this.db.list(`${this.firebaseMessage}/${chatDiologId}`).push({
            "attachment_url": msg,
            "chat_dialog_id": chatDiologId,
            "firebase_message_time": serverTime,
            "message": "",
            "message_time": last_message_time,
            "message_type": messageType,
            "job_id": jobId,
            "user_id": userId,
            "receiver_id": userId,
            "sender_id": jobId,
        });
        var aa = this.db.object(`${this.firebaseMessage}/${chatDiologId}/${messagePush.key}/`).update({
            "message_id": messagePush.key
        });
        this.removeMessage(chatDiologId, messagePush.key)
        this.db.list(`${this.firebaseNotification}`).push({
            "attachment_url": msg,
            "chat_dialog_id": chatDiologId,
            "firebase_message_time": serverTime,
            "message": "",
            "message_id": messagePush.key,
            "message_time": last_message_time,
            "message_type": messageType,
            "receiver_id": userId,
            "sender_id": jobId
        });

        var messageTimeArr = {};
        messageTimeArr[userId] = last_message_time;
        var messageTypeArr = {};
        messageTypeArr[userId] = 1;
        messageTypeArr[jobId] = 1;
        var lastMessageArr = {};
        lastMessageArr[userId] = msg;
        lastMessageArr[jobId] = msg;
        var deleteTime = {};
        deleteTime[userId] = 0;
        deleteTime[jobId] = 0;
        var unreadMessageArr = {};
        var message_count = '1';
        if (myblock_statys == '0') {
            unreadMessageArr[userId] = parseInt(unreadMessageCount) + parseInt(message_count);
        } else {
            unreadMessageArr[userId] = parseInt(unreadMessageCount);
        }
        unreadMessageArr[jobId] = 0;

        this.db.object(`${this.firebaseChats}/${chatDiologId}`).update({
            "last_message_time": last_message_time,
            "last_message_type": messageType,
            "last_message_sender_id": jobId,
            "last_message": lastMessageArr,
            "last_message_id": messagePush.key,
            "unread_count": unreadMessageArr
        });
    }

    removeMessage(chat_dialog_id, message_id) {

        // if (this.messageListener) {
        //     this.messageListener.unsubscribe();
        // }

        // this.messageListener = this.db.list(`${this.firebaseMessage}`,
        //     query => query
        //         .orderByChild("chat_dialog_id")
        //         .equalTo(chat_dialog_id)
        //     //.limitToLast(10)
        // ).valueChanges().subscribe(list => {
        //     let chatDialog = list ? list[0] : [];
        //     console.log('chatDialog', chatDialog)
        // })

        //this.db.object(`${this.firebaseMessage}/${chat_dialog_id}/${message_id}`).remove();

        // setTimeout(() => {
        //     this.db.object(`${this.firebaseMessage}/${chat_dialog_id}/${message_id}`).remove();
        // }, 10000);
    }

    serverTime() {
        var data = new Promise((resolve, reject) => {
            this.api.stopLoader();
            let data1 = {}
            this.api.getData(apiUrl._serverCurrentTime, data1).subscribe(async (res) => {
                resolve(new Date(res.data.date).getTime());
            },
                err => {
                    reject(new Date().getTime())
                    console.log(err, "err");
                });
        });
        return data;

    }

    /*deleteUserChat(jobId: string,userId: string,chatDiologId: string) {
        this.db.object(`${this.firebaseMessage}/${chatDiologId}/`).remove()
        this.db.object(`${this.firebaseUsers}/${userId}/`).remove()
        this.db.object(`${this.firebaseJobs}/${jobId}/`).remove()
        this.db.object(`${this.firebaseChats}/${chatDiologId}/`).remove()
        return this.db.object(`${this.firebaseNotification}/${chatDiologId}/`).remove();
    }*/
}